(function($) {
    'use strict';

    let windowWidth = $(window).outerWidth();
    let $body = $(document.body);
    let $html = $('html');
    let $header = $('#site-header');
    let $flyout = $('.main-menu-content');
    let $breadcrumb = $('.menu-breadcrumbs');
    let $contact_overlay = $('.contact-overlay');
    let $search_overlay = $('.search-overlay');

    // Handle nav indicator (snap highlight on hover)

    let $mainMenu = $('.main-menu');
    let $navIndicator = $('.nav-indicator');
    let navIndicatorHideTimeout = null;

    $mainMenu.on('mouseenter', '.main-nav-link, .open-search', function() {
        if (windowWidth <= 1023) {
            return;
        }
        clearTimeout(navIndicatorHideTimeout);
        let rect = this.getBoundingClientRect();
        let anchor = getFixedContainingBlockRect($navIndicator[0]);
        let position = {
            top: (rect.top - anchor.top) + 'px',
            left: (rect.left - anchor.left) + 'px',
            width: rect.width + 'px',
            height: rect.height + 'px'
        };

        if (parseFloat($navIndicator.css('opacity')) > 0) {
            // Still visible (moving directly between adjacent links) — let
            // it slide smoothly to the new spot.
            $navIndicator.css(position);
        } else {
            // Fully hidden (mouse was away from the menu for a moment) —
            // jump straight to the new link's position while invisible, so
            // it doesn't slide over from wherever it was last shown while
            // fading back in.
            $navIndicator.css('transition', 'none');
            $navIndicator.css(position);
            $navIndicator[0].offsetHeight;
            $navIndicator.css('transition', '');
        }

        $navIndicator.css('opacity', 1);
    });

    $mainMenu.on('mouseleave', '.main-nav-link, .open-search', function() {
        if (windowWidth <= 1023) {
            return;
        }
        clearTimeout(navIndicatorHideTimeout);
        navIndicatorHideTimeout = setTimeout(function() {
            $navIndicator.css('opacity', 0);
        }, 0);
    });

    function getFixedContainingBlockRect(el) {
        let node = el.parentElement;
        while (node && node !== document.body) {
            let cs = getComputedStyle(node);
            if (
                cs.transform !== 'none' || cs.translate !== 'none' || cs.scale !== 'none' ||
                cs.rotate !== 'none' || cs.filter !== 'none' || cs.backdropFilter !== 'none' ||
                cs.willChange === 'transform' || cs.willChange === 'filter' || cs.perspective !== 'none' ||
                cs.contain === 'layout' || cs.contain === 'paint' || cs.contain === 'strict' || cs.contain === 'content'
            ) {
                return node.getBoundingClientRect();
            }
            node = node.parentElement;
        }
        return { top: 0, left: 0 };
    }

    $mainMenu.on('mouseleave', function() {
        $navIndicator.css('opacity', 0);

        // Close an open sub-menu once the cursor leaves the desktop nav
        // entirely, instead of requiring another click on its toggle.
        if (windowWidth <= 1023 || !$header.hasClass('sub-menu-open')) {
            return;
        }

        $('.menu-item-has-children').removeClass('active');
        $('.default-open').removeClass('default-open');
        $header.removeClass('sub-menu-open child-menu-open');
        $breadcrumb.find('span:first').removeClass('hide-sub-menu');
        $breadcrumb.find('.divider, span:last').remove();
    });

    // Keep child-menu (mega menu second column) from overflowing past the
    // bottom of its sub-menu — pin it to the bottom instead of clipping it.

    $mainMenu.on('mouseenter focusin', '.sub-menu > li', function() {
        if (windowWidth <= 1023) {
            return;
        }

        // Interacting with any category hands control over to :hover/:focus-within,
        // so the default-open first category doesn't stay forced open alongside it.
        $(this).siblings().removeClass('default-open');

        let $childMenu = $(this).children('.child-menu');

        if (!$childMenu.length) {
            return;
        }

        let subMenu = $(this).closest('.sub-menu')[0];
        let subMenuStyle = getComputedStyle(subMenu);
        // Reserve a 1rem gap (matching the sub-menu's own bottom spacing,
        // e.g. its last item's pb-8) so the child-menu doesn't end up flush
        // against the panel edge when its content is tall enough to reach it.
        let subMenuBottom = subMenu.getBoundingClientRect().bottom - parseFloat(subMenuStyle.paddingBottom || 0) - 16;

        $childMenu.css('transform', '');

        let overflow = $childMenu[0].getBoundingClientRect().bottom - subMenuBottom;

        if (overflow > 0) {
            $childMenu.css('transform', 'translateY(-' + Math.ceil(overflow) + 'px)');
        }
    });

    // Handle flyout

    $body.on('click', '.menu-overlay', function(e) {
        if (e.target !== this) {
            return;
        }
        $body.trigger('flyout/hide');
    });

    if (!$html.hasClass('menu-open')) {
        $body.on('click', '.main-menu-open', function() {
            $('body').attr('data-pos', $(window).scrollTop());
            $html.addClass('menu-open');
            $body.trigger('contact/hide');
            history.pushState({}, '');
        });
    } else {
        $body.trigger('flyout/hide');
    }

    class Flyout {
        constructor() {
            $body.on(
                'click',
                '.main-menu-close',
                this.flyout_hide,
            );
            $(document).on('flyout/hide', this.flyout_hide);
        }

        flyout_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $flyout.addClass('close');

            setTimeout(function() {
                $flyout.removeClass('close');
                $html.removeClass('menu-open search-open');
                $('.menu-item-has-children').removeClass('active');
                $header.removeClass('sub-menu-open child-menu-open');
                $breadcrumb.find('span:first')
                    .removeClass('hide-sub-menu, hide-child-menu')
                    .text('Meny');
                $breadcrumb.find('span:nth-child(2), span:nth-child(3)')
                    .remove();

                setTimeout(function() {
                    if ($header.hasClass('transparent')) {

                    }
                }, 600);

            }, 300);
        };
    }

    new Flyout();

    // Handle Main menu

    $body.on('click', '.sub-menu-toggle', function(e) {
        $(this).parent().siblings().removeClass('active');
        $html.removeClass('search-open contact-open');
        $contact_overlay.removeClass('active');
        $search_overlay.removeClass('active');

        if (windowWidth <= 1023 && $header.hasClass('sub-menu-open')) {
            $html.removeClass('menu-open');
        }

        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
            $header.removeClass('sub-menu-open');
            $breadcrumb.find('span:first').removeClass('hide-sub-menu');
            $breadcrumb.find('.divider, span:last').remove();

        } else {
            $(this).parent().addClass('active');
            if (windowWidth <= 1023) {
                $html.addClass('menu-open');
            } else {
                // On desktop, a category's child-menu should be open from
                // the start instead of requiring a hover before any content
                // shows: prefer the category the visitor is currently
                // browsing (current page or one of its ancestors), falling
                // back to the first real category otherwise. The sub-menu's
                // own first <li> is a mobile-only "back" link with no
                // child-menu, so it's excluded from both.
                let $categories = $(this).parent().find('.sub-menu > li');
                $categories.removeClass('default-open');

                let $hasChildMenu = $categories.filter(function() {
                    return $(this).children('.child-menu').length > 0;
                });
                let $currentCategory = $hasChildMenu.filter(
                    '.current-menu-item, .current-menu-parent, .current-menu-ancestor'
                ).first();

                ($currentCategory.length ? $currentCategory : $hasChildMenu.first())
                    .addClass('default-open');
            }
            $header.addClass('sub-menu-open');
            $breadcrumb.find('span:first').addClass('hide-sub-menu');
            $breadcrumb.append(
                '<span class="divider">/</span><span class="menu-breadcrumb">' +
                $(this).text() +
                '</span>');
            history.pushState({}, '');

        }
    });

    $(window).resize(function() {
        windowWidth = $(window).outerWidth();
        $body.on('click', '.sub-menu-toggle', function(e) {
            if ($(this).parent().hasClass('active')) {
            } else {
                if ($header.hasClass('transparent')) {
                    if (windowWidth > 1023) {
                        $header.addClass('black');
                    }
                }
            }
        });
    });

    $body.on('click', '.child-menu-toggle', function(e) {
        if (windowWidth > 1023) {
            // Desktop already reveals the child-menu on hover, so a click
            // here should navigate to the category's own page instead of
            // toggling anything.
            return;
        }

        e.preventDefault();

        var text = $(this).clone().children().remove().end().text();
        if ($(this).hasClass('active')) {
            $('.child-menu').removeClass('active');
            $header.removeClass('child-menu-open');

        } else {
            $(this).next().addClass('active');
            $header.addClass('child-menu-open');
            $breadcrumb.find('span:first')
                .removeClass('hide-sub-menu')
                .addClass('hide-child-menu')
                .text($(this).closest('.sub-menu').prev().text());
            $breadcrumb.find('span:last').text(text);
            history.pushState({}, '');
        }
    });

    $body.on('click', '.hide-sub-menu', function(e) {
        $('.menu-item-has-children, .child-menu').removeClass('active');
        $header.removeClass('sub-menu-open child-menu-open');
        $breadcrumb.find('span:first').removeClass('hide-sub-menu');
        $breadcrumb.find('.divider, span:last').remove();
    });

    $body.on('click', '.hide-child-menu', function(e) {
        $('.child-menu').removeClass('active');
        $header.removeClass('child-menu-open');
        $breadcrumb.find('span:last')
            .text($('li.active .sub-menu-toggle').text());
        $breadcrumb.find('span:first')
            .removeClass('hide-child-menu')
            .addClass('hide-sub-menu')
            .text('Meny');
    });

    // Handle contact overlay

    let $contactContent = $('.contact-content');

    function alignContactContent() {
        if ($(window).outerWidth() <= 1023) {
            $contactContent.css({ marginLeft: '', width: '' });
            return;
        }

        let $mainMenu = $('.main-menu-content');

        if (!$mainMenu.length) {
            return;
        }

        $contactContent.css({ marginLeft: '', width: '' });

        let mainMenuRect = $mainMenu[0].getBoundingClientRect();
        let currentLeft = $contactContent[0].getBoundingClientRect().left;

        $contactContent.css({
            marginLeft: (mainMenuRect.left - currentLeft) + 'px',
            width: mainMenuRect.width + 'px'
        });
    }

    $body.on('click', '.header-cta', function(e) {
        if (!$html.hasClass('contact-open')) {
            $('.header-cta').removeClass('gtm-button');
            $('body').attr('data-pos', $(window).scrollTop());
            alignContactContent();
            $html.addClass('contact-open');
            $contact_overlay.addClass('active');
            $html.removeClass('menu-open search-open');
            $('.menu-item-has-children').removeClass('active');
            $search_overlay.removeClass('active');
            history.pushState({}, '');
        } else {
            $body.trigger('contact/hide');
        }
    });

    $(window).on('resize', function() {
        if ($html.hasClass('contact-open')) {
            alignContactContent();
        }
    });

    $body.on('click', '.contact-overlay', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('contact/hide');

    });

    class Contact {
        constructor() {
            $(document).on('contact/hide', this.contact_hide);
        }

        contact_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $contact_overlay.removeClass('active');

            setTimeout(function() {
                $html.removeClass('contact-open');
            }, 300);
        };
    }

    new Contact();

    // Close the contact overlay once the cursor leaves its content, same as
    // the sub-menu closing when the mouse leaves the desktop nav.

    $contactContent.on('mouseleave', function() {
        if (windowWidth <= 1023 || !$html.hasClass('contact-open')) {
            return;
        }

        $body.trigger('contact/hide');
    });

    // Handle contact flyout tabs (Förfrågan / Kontakt)

    $body.on('click', '.contact-tab', function(e) {
        e.preventDefault();

        let $tab = $(this);

        if ($tab.hasClass('active')) {
            return;
        }

        let target = $tab.data('tab');
        let $panels = $('.contact-tab-panel');
        let $current = $panels.filter('.active');
        let $next = $panels.filter('[data-tab-panel="' + target + '"]');
        let $wrapper = $current.closest('.contact-tab-panels');

        $('.contact-tab').removeClass('active');
        $tab.addClass('active');

        // $wrapper is border-box with its own vertical padding, so the CSS
        // `height` we animate has to include that padding — animating to a
        // content-only height shrinks the visible area and clips the panel
        // until the inline height is cleared at the end (seen as a jump).
        let wrapperPadding = $wrapper.innerHeight() - $wrapper.height();

        $wrapper.stop(true, false).css('height', $wrapper.innerHeight());

        $current.stop(true, true).fadeOut(200, function() {
            $current.removeClass('active');
            $next.addClass('active');

            $next.css({ position: 'absolute', visibility: 'hidden', display: 'block', width: $wrapper.width() });
            let targetHeight = $next.outerHeight() + wrapperPadding;
            $next.css({ position: '', visibility: '', display: 'none', width: '' });

            $wrapper.animate({ height: targetHeight }, 300, function() {
                $wrapper.css('height', '');
            });

            $next.fadeIn(200);
        });
    });

    // Handle "Flikar" (tabs) blocks — scoped per-instance via .closest()
    // since multiple tabs blocks can exist on the same page.

    $body.on('click', '.tabs-tab', function(e) {
        e.preventDefault();

        let $tab = $(this);

        if ($tab.hasClass('active')) {
            return;
        }

        let target = $tab.data('tab');
        let $nav = $tab.closest('.tabs-nav');
        let $panels = $nav.siblings('.tabs-panels').find('.tabs-tab-panel');

        $nav.find('.tabs-tab').removeClass('active');
        $tab.addClass('active');

        $panels.removeClass('active').attr('inert', '');
        $panels.filter('[data-tab-panel="' + target + '"]')
            .addClass('active')
            .removeAttr('inert');
    });

    // Handle header search

    $body.on('click', '.open-search', function(e) {
        if (!$html.hasClass('search-open')) {
            $('#search').focus();
            $('body').attr('data-pos', $(window).scrollTop());
            $html.addClass('search-open');
            $search_overlay.addClass('active');
            $html.removeClass('contact-open');
            $contact_overlay.removeClass('active');
            history.pushState({}, '');

            if (windowWidth > 1023) {
                $html.removeClass('menu-open');
                $header.removeClass('sub-menu-open child-menu-open');
                $('.menu-item-has-children').removeClass('active');

                if ($header.hasClass('transparent')) {
                    $header.addClass('black');
                }
            }

        } else {
            $body.trigger('search/hide');
        }
    });

    $(window).resize(function() {
        windowWidth = $(window).outerWidth();
        $body.on('click', '.open-search', function(e) {
            if (!$html.hasClass('search-open')) {
                if (windowWidth > 1023) {
                    $html.removeClass('menu-open');
                    $header.removeClass('sub-menu-open child-menu-open');
                    $('.menu-item-has-children').removeClass('active');
                }
            }
        });
    });

    $body.on('click', '.search-overlay', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('search/hide');

    });

    $body.on('click', '.search-close', function(e) {
        $body.trigger('search/hide');
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $html.hasClass('search-open')) {
            $body.trigger('search/hide');
        }
    });

    class Search {
        constructor() {
            $(document).on('search/hide', this.search_hide);
        }

        search_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $search_overlay.removeClass('active');

            setTimeout(function() {
                $html.removeClass('search-open');

                if ($header.hasClass('transparent')) {
                    $header.removeClass('black');
                }

            }, 300);
        };
    }

    new Search();

    // Handle browser go back

    window.onpopstate = function() {
        $body.trigger('flyout/hide');
        $body.trigger('contact/hide');
        $body.trigger('search/hide');
    };

    // Handle hero clock (current time in Sweden)

    let $heroClock = $('.hero-clock');

    if ($heroClock.length) {
        let clockFormatter = new Intl.DateTimeFormat('sv-SE', {
            timeZone: 'Europe/Stockholm',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        let heroClockTimeout = null;

        function renderHeroClock() {
            $heroClock.text(clockFormatter.format(new Date()));
        }

        // Re-schedule against the real clock every tick instead of a fixed
        // setInterval, so long-lived tabs (throttled in the background,
        // laptop sleep/wake, etc.) never drift — each tick re-reads the
        // actual time and re-aims for the next minute boundary.
        function scheduleHeroClock() {
            renderHeroClock();
            clearTimeout(heroClockTimeout);
            let msIntoMinute = (new Date()).getSeconds() * 1000 + (new Date()).getMilliseconds();
            heroClockTimeout = setTimeout(scheduleHeroClock, 60000 - msIntoMinute + 200);
        }

        scheduleHeroClock();

        document.addEventListener('visibilitychange', function() {
            if (!document.hidden) {
                renderHeroClock();
            }
        });
    }

}(jQuery));
